<template>
    <div class="uik-progress-bar__wrapper">
        <div
            class="uik-progress-bar__progressLine"
            :class="{
                'uik-progress-bar__progressLine--primary': color === 'primary',
                'uik-progress-bar__progressLine--secondary': color === 'secondary',
                'uik-progress-bar__progressLine--warning': color === 'warning',
                'uik-progress-bar__progressLine--error': color === 'error',
                'uik-progress-bar__progressLine--success': color === 'success'
            }"
            :style="'width:' + fill + '%;' + bgColor"/>
    </div>
</template>

<script>
export default {
    name: "UikProgressBar",
    props: {
        fill: { type: String, default: "0" },
        color: { type: String, default: "primary" }
    },
    computed: {
        bgColor () {
            if (
                this.color === "primary" ||
        this.color === "secondary" ||
        this.color === "warning" ||
        this.color === "error" ||
        this.color === "success"
            ) return ""
            return "background: " + this.color + ";"
        }
    }
}
</script>

<style lang="scss">
.uik-progress-bar__wrapper, .uik-progress-bar__progressLine {
  width: 100%;
  height: 4px;
  background: #EAECEE;
  border-radius: 4px;
}

.uik-progress-bar__progressLine {
  &--primary { background: $primary !important; }
  &--secondary { background: $secondary !important; }
  &--warning { background: $warning !important; }
  &--error { background: $error !important; }
  &--success { background: $success !important; }
}
</style>
